import { createFileRoute } from "@tanstack/react-router";

import SetlistsCreateUpdate from "@/features/gigs/SetlistsCreateUpdate";
import SideNavLayout from "@/layouts/SideNavLayout";
import { GigsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/gigs/setlists/create")({
  component: () => (
    <SideNavLayout menu={<GigsMenu />}>
      <SetlistsCreateUpdate key="create" />
    </SideNavLayout>
  ),
});
